export default {
	fxRates: state => (currency = 'USD') => {
		if (!_.isEmpty(currency)) {
			return state.fxRates.find(rate => rate.currency === currency)
		}

		return state.fxRates
	},
}
